<template>
    <div class="contract-detail-modal">
        <div class="popup popup-md contract-detail-popup" >
            <div class="content">
                <small id="close-popup" @click="close()"><i class="ti ti-close"></i></small>
                <h5 class="text-left">Detail Contract<hr/></h5>
                <div class="row">
                    <div class="form-group mb-0">
                        <div class="col-sm-12">
                            <label class="text-primary mb-0"><i class="ti ti-info-alt"></i> Information Contract</label><br/>
                            <small class="text-secondary">Detail client information job contract.</small>
                            <hr/>
                        </div>
                    </div>
                    <div class="form-group mb-0">
                        <label class="col-sm-4"><i><b>Contract Status</b></i></label>
                        <label class="col-sm-8">
                            <span :class="model.status | contractStatus" style="font-size:11px;">{{ model.status }}</span>
                        </label>
                    </div>
                    <div class="form-group mb-0" v-if="model.status == 'terminate'">
                        <label class="col-sm-4">&nbsp;</label>
                        <label class="col-sm-8">
                            <span class="text-secondary ml-2">{{ model.terminate_date  | moment("DD/MM/YYYY") }} - {{ model.terminate_desc }}</span>
                        </label>
                    </div>

                    <div class="form-group mb-0">
                        <label class="col-sm-4"><i><b>Number of Contract</b></i></label>
                        <label class="col-sm-8"><i> # {{model.contract_number }}</i></label>
                    </div>
                    <div class="form-group mb-0 mb-0">
                        <label class="col-sm-4"><i>Contract Value (IDR)</i></label>
                        <label class="col-sm-8">Rp.{{ model.contract_value }}</label>
                    </div>
                    <div class="form-group mb-0 mb-0">
                        <label class="col-sm-4"><i>Contract Date</i></label>
                        <label class="col-sm-8">{{ model.contract_date | moment("DD/MM/YYYY") }}</label>
                    </div>
                    <div class="form-group mb-0 mb-0">
                        <label class="col-sm-4"><i>Contract - <span class="text-success">Start Date</span> </i></label>
                        <label class="col-sm-8">{{ FormatDate(model.start_date) }}</label>
                    </div>
                    <div class="form-group mb-0 mb-0">
                        <label class="col-sm-4"><i>Contract - <span class="text-danger">End Date</span> </i></label>
                        <label class="col-sm-8">{{ FormatDate(model.end_date) }}</label>
                    </div>
                    <div class="form-group mb-0 mb-0">
                        <label class="col-sm-4"><i>Shift Working Hours</i></label>
                        <label class="col-sm-8">
                            <span v-for="(shift, index) in contractShifts" :key="index" class="shift-duration">
                                {{ shift.name }} · {{ shift.hour }} · {{ shift.working_hours }} hours
                            </span>
                            <span v-if="contractShifts.length === 0">Legacy contract · {{ model.working_hours }} hours</span>
                        </label>
                    </div>
                    <div class="form-group mb-0 mb-0">
                        <label class="col-sm-4"><i>Man Power Request</i></label>
                        <label class="col-sm-8" v-if="model.man_power !== undefined">
                            <span v-for="(initems, index) in JSON.parse(model.man_power)" :key="index">
                                {{ initems.total }} ( {{ initems.job }} )
                                <span v-if="(index % 2== 0)">,</span>
                            </span>
                        </label>
                    </div>
                    <div class="form-group mb-0">
                        <label class="col-sm-4"><i>Contract Description</i></label>
                        <label class="col-sm-8">{{model.description !== null ?  model.description : '....' }}</label>
                    </div>
                    <div class="form-group mb-0">
                        <div class="col-sm-12">
                            <label class="text-primary mb-0"><i class="ti ti-info-alt"></i> Client Base</label><br/>
                            <small class="text-secondary">Detail information client.</small>
                            <hr/>
                        </div>
                    </div>
                    <div class="form-group mb-0">
                        <label class="col-sm-4"><i>Client Name</i></label>
                        <label class="col-sm-8">{{model.client_name }}</label>
                    </div>
                    <div class="form-group mb-0">
                        <label class="col-sm-4"><i>Email Address</i></label>
                        <label class="col-sm-8">{{model.email }}</label>
                    </div>
                    <div class="form-group mb-0">
                        <label class="col-sm-4"><i>Phone Number</i></label>
                        <label class="col-sm-8">{{model.phone_number }}</label>
                    </div>
                    <div class="form-group">
                        <label class="col-sm-4"><i>Client Address / Station Base</i></label>
                        <label class="col-sm-8">
                            {{model.office_address }}<br/>
                            <span class="text-secondary">{{ model.proname }} - {{ model.regname }}</span>
                        </label>
                    </div>

                    <div class="form-group">
                        <div class="col-sm-12">
                            <label class="text-primary mb-0"><i class="ti ti-info-alt"></i> Detail Area Client Base</label><br/>
                            <small class="text-secondary">Detail information area station.</small>
                            <hr/>
                        </div>
                    </div>
                    <div class="form-group mt-0 mb-0" v-for="(items, idx) in section" :key="idx">
                        <span class="ml-2"># Section {{ idx  }}</span><br/><br/>
                        <div class="row" v-for="(row, idx) in items" :key="idx">
                            <label class="col-sm-4 mb-2"><i class="ti ti-check text-success"></i> {{ row.area_name }}</label>
                            <label class="col-sm-5"><i>{{ row.area_task !== null ? row.area_task : '.........' }}</i></label>
                            <label class="col-sm-3">
                                Floor <b>{{ row.area_floor }} ( {{ row.area_type }} )</b>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import axios from 'axios';
    import { mapState } from 'vuex';

    export default 
    {
        props:['id_contract'],
        data() {
            return {
                meta_url : 'contract',
                sdate: new Date( Date.now() + -6*24*3600*1000 ).toISOString().slice(0,10),
                model: [],
                section:[]
            }
        },
        computed:{
            contractShifts() {
                if (!this.model.contract_shift) return [];
                try {
                    const shifts = JSON.parse(this.model.contract_shift) || [];
                    return shifts.map((shift) => Object.assign({}, shift, {
                        working_hours: Number(shift.working_hours || this.model.working_hours || 8)
                    }));
                } catch (error) {
                    return [];
                }
            }
        },
        created() {
            this.DataQuery()
        },
      
        methods: {
            close(){
                this.$emit('exit');
            },

            FormatDate(date)
            {
                return this.$moment(date).format("DD/MM/YYYY")
            },

            async DataQuery()
            {
                this.$store.state.loading.msg = 'Query Detail Contract';
                this.$store.state.loading.status = false;

                await axios.get( this.meta_url+'/find/'+this.id_contract)
                .then((res) => {
                    let query    = res.data;
                    this.model   = query.data;
                    this.section = query.section;
                }).finally(() => {
                    this.$store.state.loading.status = false;
                });
            },
        },
    }
</script>

<style scoped>
.contract-detail-popup{align-items:center;bottom:0;display:flex;justify-content:center;left:0;margin:0;overflow-y:auto;padding:24px;position:fixed;right:0;top:0!important;width:100vw;z-index:1250}.contract-detail-popup:before{z-index:0}.contract-detail-popup .content{border-radius:14px;box-shadow:0 24px 70px rgba(0,0,0,.3);float:none;margin:auto;max-height:calc(100vh - 48px);max-width:900px;overflow-y:auto;padding:24px 28px;width:100%}.contract-detail-popup .content>h5{color:#294158;font-size:18px;font-weight:700;padding-right:35px}.contract-detail-popup #close-popup{align-items:center;background:#eef3f6;border-radius:50%;display:flex;height:32px;justify-content:center;right:18px;top:18px;width:32px}.contract-detail-popup .row>.form-group{align-items:flex-start;border-bottom:1px solid #edf1f4;display:flex;float:none;margin:0!important;padding:10px 8px!important;width:100%}.contract-detail-popup .row>.form-group>label:first-child{color:#647487;font-weight:600}.contract-detail-popup .row>.form-group>.col-sm-12{background:#f2f8fa;border-radius:8px;padding:13px}.contract-detail-popup .shift-duration{background:#edf6f7;border-radius:6px;color:#476b72;padding:5px 8px}
.popup .content .form-group label{
    display: inline-block;
}
.popup .content .form-group{padding:5px; margin-bottom:0;}
.shift-duration{display:block; margin-bottom:3px; text-transform:capitalize;}
@media(max-width:767px){.contract-detail-popup{align-items:flex-start;padding:12px}.contract-detail-popup .content{margin:0;max-height:calc(100vh - 24px);padding:20px 14px}.contract-detail-popup .row>.form-group{display:block}.contract-detail-popup .row>.form-group>label{display:block!important;float:none;padding:3px 0;width:100%}}
</style>
